<ng-container *ngFor="let slide of getSlides(); let i = index">
    <div class="image-container" *ngIf="i === currentSlide" [style.background-image]="slide" [@slideAnimation]="animationType" ></div>
</ng-container>